(() => {
  const excluded = 'script, style, noscript, textarea, input, select, [contenteditable="true"]';
  function normalize(root) {
    if (root.nodeType === Node.TEXT_NODE) {
      if (!root.parentElement || root.parentElement.closest(excluded)) return;
      const next = root.nodeValue.replace(/\bTRY\b/g, 'TL');
      if (next !== root.nodeValue) root.nodeValue = next;
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE || root.matches(excluded)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) normalize(walker.currentNode);
    for (const element of [root, ...root.querySelectorAll('[aria-label], [title]')]) {
      if (element.closest(excluded)) continue;
      for (const name of ['aria-label', 'title']) {
        const value = element.getAttribute(name);
        if (value && /\bTRY\b/.test(value)) element.setAttribute(name, value.replace(/\bTRY\b/g, 'TL'));
      }
    }
  }
  normalize(document.body);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'characterData') normalize(record.target);
      else if (record.type === 'attributes') normalize(record.target);
      else record.addedNodes.forEach(normalize);
    }
  }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-label', 'title'] });
})();
